import { render, staticRenderFns } from "./ServiceDocuments.vue?vue&type=template&id=dfacea72&scoped=true"
import script from "./ServiceDocuments.vue?vue&type=script&lang=ts"
export * from "./ServiceDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfacea72",
  null
  
)

export default component.exports